var _rect, _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDummyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.799805,
    y: 0.800049,
    width: 114,
    height: 114,
    rx: 57,
    fill: "#F3F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.3201 77.8H68.2801C73.8001 77.8 76.0001 74.42 76.2601 70.3L77.3001 53.78C77.5801 49.46 74.1401 45.8 69.8001 45.8C68.5801 45.8 67.4601 45.1 66.9001 44.02L65.4601 41.12C64.5401 39.3 62.1401 37.8 60.1001 37.8H55.5201C53.4601 37.8 51.0601 39.3 50.1401 41.12L48.7001 44.02C48.1401 45.1 47.0201 45.8 45.8001 45.8C41.4601 45.8 38.0201 49.46 38.3001 53.78L39.3401 70.3C39.5801 74.42 41.8001 77.8 47.3201 77.8Z",
    stroke: "#D4D4D4",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7998 49.8H60.7998",
    stroke: "#D4D4D4",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7998 69.8C61.3798 69.8 64.2998 66.88 64.2998 63.3C64.2998 59.72 61.3798 56.8 57.7998 56.8C54.2198 56.8 51.2998 59.72 51.2998 63.3C51.2998 66.88 54.2198 69.8 57.7998 69.8Z",
    stroke: "#D4D4D4",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9248 110.549C101.866 110.549 109.925 102.49 109.925 92.5491C109.925 82.6079 101.866 74.5491 91.9248 74.5491C81.9837 74.5491 73.9248 82.6079 73.9248 92.5491C73.9248 102.49 81.9837 110.549 91.9248 110.549Z",
    fill: "#292D33"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12_111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 83,
    width: 19,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.782 83.5491H83.7822V101.549H101.782V83.5491Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0322 99.2994C85.6197 99.2994 85.2666 99.1526 84.9728 98.8588C84.6791 98.5651 84.5322 98.2119 84.5322 97.7994V88.7994C84.5322 88.3869 84.6791 88.0338 84.9728 87.7401C85.2666 87.4463 85.6197 87.2994 86.0322 87.2994H88.3947L89.7822 85.7994H94.2822V87.2994H90.4385L89.0697 88.7994H86.0322V97.7994H98.0322V91.0494H99.5322V97.7994C99.5322 98.2119 99.3853 98.5651 99.0916 98.8588C98.7978 99.1526 98.4447 99.2994 98.0322 99.2994H86.0322ZM98.0322 88.7994V87.2994H96.5322V85.7994H98.0322V84.2994H99.5322V85.7994H101.032V87.2994H99.5322V88.7994H98.0322ZM92.0322 96.6744C92.9697 96.6744 93.7666 96.3463 94.4228 95.6901C95.0791 95.0338 95.4072 94.2369 95.4072 93.2994C95.4072 92.3619 95.0791 91.5651 94.4228 90.9088C93.7666 90.2526 92.9697 89.9244 92.0322 89.9244C91.0947 89.9244 90.2978 90.2526 89.6416 90.9088C88.9853 91.5651 88.6572 92.3619 88.6572 93.2994C88.6572 94.2369 88.9853 95.0338 89.6416 95.6901C90.2978 96.3463 91.0947 96.6744 92.0322 96.6744ZM92.0322 95.1744C91.5072 95.1744 91.0635 94.9932 90.701 94.6307C90.3385 94.2682 90.1572 93.8244 90.1572 93.2994C90.1572 92.7744 90.3385 92.3307 90.701 91.9682C91.0635 91.6057 91.5072 91.4244 92.0322 91.4244C92.5572 91.4244 93.001 91.6057 93.3635 91.9682C93.726 92.3307 93.9072 92.7744 93.9072 93.2994C93.9072 93.8244 93.726 94.2682 93.3635 94.6307C93.001 94.9932 92.5572 95.1744 92.0322 95.1744Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyProfile);
export default __webpack_public_path__ + "static/media/dummy-profile.e37beb253fdee4b366730cd16d534289.svg";
export { ForwardRef as ReactComponent };